import { andVobFilter } from '@iotv/core-services';
import { getChildEdgeTypeId } from '@iotv/datamodel-core';
import { TypeIcons } from '../../../Iconography';
import { AdjacentType } from '../../../types';
export const getCustomerPropertyAreaPlacePath = ({ filters }) => {
    const placeSubPath = {
        stepQuery: {
            objectTypeId: 'Place',
            adjacencyType: AdjacentType.CHILD,
            edgeTypeId: getChildEdgeTypeId('Area', 'Place'),
        },
        endIcon: TypeIcons.Place,
        nextSteps: [],
    };
    const areaPlacePathRecursive = {
        renderTypeFolder: false,
        stepQuery: {
            objectTypeId: 'Area',
            adjacencyType: AdjacentType.CHILD,
            edgeTypeId: getChildEdgeTypeId('Area', 'Area'),
        },
        endIcon: TypeIcons.Area,
        nextSteps: [placeSubPath],
    };
    areaPlacePathRecursive.nextSteps.unshift(areaPlacePathRecursive);
    const apexQuery = {
        nodeFilter: andVobFilter(filters),
        renderTypeFolder: false,
        hideThisStep: false,
        stepQuery: {
            objectTypeId: 'Property',
            adjacencyType: AdjacentType.CHILD,
            edgeTypeId: getChildEdgeTypeId('Customer', 'Property'),
        },
        endIcon: TypeIcons.Property,
        nextSteps: [
            {
                stepQuery: {
                    objectTypeId: 'Area',
                    adjacencyType: AdjacentType.CHILD,
                    edgeTypeId: getChildEdgeTypeId('Property', 'Area'),
                },
                endIcon: TypeIcons.Area,
                nextSteps: [areaPlacePathRecursive, placeSubPath],
            },
            {
                stepQuery: {
                    objectTypeId: 'Place',
                    adjacencyType: AdjacentType.CHILD,
                    edgeTypeId: getChildEdgeTypeId('Property', 'Place'),
                },
                endIcon: TypeIcons.Place,
                nextSteps: [],
            },
        ],
    };
    return apexQuery;
};
const customerPropertyAreaPlacePath = getCustomerPropertyAreaPlacePath({ filters: [] });
export { customerPropertyAreaPlacePath };
